exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart-popup {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    z-index: 1000;\n    width: 420px;\n    height: 320px;\n    background-color: white;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n  \n  .chart-popup-content {\n    padding: 10px;\n  }\n  \n  .close-btn {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    cursor: pointer;\n    font-size: 18px;\n  }\n  ", ""]);

// exports
